// Module
var code = "Votre demande a bien été enregistrée, vous recevrez les futures offres de {client}.<br>Si vous le souhaitez, vous pourrez vous désabonner de ces emails à tout moment.";
// Exports
module.exports = code;